import React from 'react'
import apiService from 'services/api'
import { filterStoreRepo } from '../../../../Filters/FilterStore'
import FilterModal from '../../../../Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { CommonFiltersetAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetAccountGroup'
import { CommonFiltersetGooglePlaceGroup } from '../../GooglePlaceBase/GooglePlaceBaseTable/CommonFiltersetGooglePlaceGroup'
import { CONVENIENCE_COLUMNS } from '../ConvenienceColumnsInfo'

export function ConvenienceFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = apiService()
  const { data: campaignOptions } = api.useGetCampaignsOptions('convenience')

  const convenienceFilterStore = filterStoreRepo.getStore(filterIdentifier)

  return (
    <FilterModal identifier={filterIdentifier} store={convenienceFilterStore}>
      <CommonFiltersetAccountGroup
        filterStore={convenienceFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <CommonFiltersetGooglePlaceGroup
        filterStore={convenienceFilterStore}
        columns={CONVENIENCE_COLUMNS}
        companyType="convenience"
      />
    </FilterModal>
  )
}
